import axios from 'axios';

const baseUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL;


export const fetchClientById = (accessToken, clientId) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "client_select",
            'action': "SELECT_BY_CLIENT_ID",
            'findOne': "true",
            'variables': JSON.stringify({
                'id_client': clientId
            })
        })
    });
};
export const fetchClientByNit = (accessToken, nit) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "client_select",
            'action': "SELECT_BY_IDENTIFICATION",
            'variables': JSON.stringify({
                'identification': nit
            })
        })
    });
};

export const fetchClientOfficeId = (accessToken, clientId) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "client_select",
            'action': "SELECT_BY_CLIENT_OFFICE_ID",
            'variables': JSON.stringify({
                'id_client': clientId
            })
        })
    });
};


export const deleteOffice = (accessToken, variables) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'client_alter',
            'action': 'DELETE_OFFICE',
            'variables': JSON.stringify(variables)
        })
    })
}


export const updateClient = (data, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "client_alter",
            'action': "UPDATE",
            "variables": data
        })
    });
};

export const insertDataClient = (data, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            process: "client_alter",
            action: "INSERT",
            variables: data
        })
    })
};


export const updateOffice = (accessToken, variables) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'client_alter',
            'action': 'UPDATE_OFFICE',
            'variables': JSON.stringify(variables)
        })
    })
}


export const getCompanies = (id_user_action, accessToken) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'user_select',
            'action': 'SELECTCOMPANIES_CLIENT',
            'variables': JSON.stringify({ 'id_user_action': id_user_action })
        })
    })
}

export const fetchClientsConcat = (accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            "process": "client_select",
            "action": "SELECT_CONCAT",
            "variables": `{}`
        })
    });
}

export const fetchOffices = (idClient, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            "process": "client_select",
            "action": "SELECT_OFFICES_BY_ID",
            "variables": JSON.stringify({ id_client: idClient })
        })
    });
}